<template>
  <v-container>
    <v-row v-if="normalizationList.length > 0" justify="center" align="center">
      <v-col class="d-flex justify-center align-center" cols="12" lg="12">
        <v-btn
          class="ct-text-bolder d-flex justify-space-between align-stretch white--text"
          color="#44671B"
          :title="`下載${id}圖表`"
          x-large
          @click="screenShot(id)"
        >
          <v-icon right>mdi-tray-arrow-down</v-icon>
          <span class="ml-4" style="display:inline-block">下載圖表</span>
        </v-btn>
      </v-col>
      <v-col cols="12" lg="12">
        <div class="d-flex justify-center align-center " :id="id"></div>
      </v-col>
    </v-row>
    <v-row v-else justify="center" align="center">
      <v-col cols="12" lg="12" style="text-align: center;">
        <span
          class="d-block"
          style="font-size:1.25rem; font-weight:600; color:#D92C3F"
        >
          無相關觀數據統計
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import html2canvas from "html2canvas/dist/html2canvas";
export default {
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    dataList: {
      type: Array,
      default() {
        return [];
      }
    },
    typeList: {
      type: Array,
      default() {
        return [];
      }
    },
    xLabel: {
      type: String,
      default: null
    },
    yLabel: {
      type: String,
      default: null
    },
    labelKey: {
      type: String,
      default: null
    },
    sumKey: {
      type: String,
      default: "count"
    },
    downloadFileName: {
      type: String,
      default: "screenShot"
    }
  },
  computed: {
    // distinct() {

    // }
    sum() {
      const sum = 0;
      return this.dataList.reduce((a, c) => {
        if (this.sumKey) {
          return a + this.TOOL.toNumber(c[this.sumKey]);
        } else {
          return this.TOOL.toNumber(a) + this.TOOL.toNumber(c);
        }
      }, sum);
    },
    normalizationList() {
      // .filter(p => p[this.sumKey])
      return this.dataList
        .map(p => {
          return {
            name: p.name,
            count: parseFloat(this.TOOL.toNumber(p[this.sumKey]).toFixed(1)),
            percent: (
              this.TOOL.toNumber(p[this.sumKey] / this.sum) * 100
            ).toFixed(1)
          };
        })
        .sort((a, b) => {
          if (a.count - b.count < 0) {
            return 1;
          } else {
            return -1;
          }
        });
    }
  },
  mounted() {
    this.CHART.barChart(this.id, this.normalizationList, this.typeList, {
      yLabel: this.yLabel,
      xLabel: this.xLabel,
      labelKey: this.labelKey
    });
  },
  methods: {
    async screenShot(canvasInstance, triggerDownload = true) {
      const canvas = await html2canvas(
        typeof canvasInstance === "string"
          ? document.getElementById(canvasInstance)
          : canvasInstance,
        {
          allowTaint: true,
          useCORS: true,
          scale: 3,
          backgroundColor: "white",
          imageTimeout: 600000
        }
      );

      if (triggerDownload) {
        const a = document.createElement("a");
        a.href = canvas
          .toDataURL("image/jpeg")
          .replace("image/jpeg", "image/octet-stream");
        a.download = `${this.downloadFileName}.jpg`;
        a.click();
      }

      return canvas;
    }
  }
};
</script>
<style></style>
